import { cx } from '@lastbrand/web-ui-styled-system/css'

import { FormattedPrice } from '@src/blocks/currency/currency.component'

import { OfferStyleKey } from './price-display-state'
import * as styles from './product-info-price-ds.styles'

export interface OfferPriceValueProps {
  formattedSubscriptionPrice?: string
  formattedFestivalOfferPrice?: string
  isSubscriptionOffer: boolean
  offerStyleKey: OfferStyleKey
}

const priceWrapperMainValueStylesToApply = {
  festivalOffer: [styles.festivalOfferCss],
  subscriptionOffer: [styles.subscriptionOfferCss],
  default: [],
}

function OfferPriceValue({
  formattedSubscriptionPrice,
  formattedFestivalOfferPrice,
  isSubscriptionOffer,
  offerStyleKey,
}: OfferPriceValueProps) {
  return (
    <div
      className={cx(
        styles.priceWrapperMainValueCss,
        styles.priceWrapperMainValueQpOfferCss,
        ...priceWrapperMainValueStylesToApply[offerStyleKey],
      )}
    >
      <span className="festival_sale_price_selector_for_force_update">
        <FormattedPrice
          amount={
            isSubscriptionOffer && formattedSubscriptionPrice
              ? formattedSubscriptionPrice
              : formattedFestivalOfferPrice
                ? formattedFestivalOfferPrice
                : ''
          }
        />
      </span>
    </div>
  )
}

export default OfferPriceValue
